import { Component } from '@angular/core';

@Component({
  selector: 'app1',
  templateUrl: './app1.component.html'
})
export class App1Component {
  text = 'Hello world';
  diffuseColor = '#dd3300';
  specularColor = '#ee9966';

  ngOnInit() {
    if (window['x3dom']) { window['x3dom'].reload(); }
  }
}